import {
  Bar
} from 'vue-chartjs'
import {
  Agent
} from 'http'
import moment from "moment";

export default {
  extends: Bar,
  props: ['sumVerr', 'sumUnBez', 'sumMonth', 'sumBez'],
  data() {
    return {
      chartdata: {
        datasets: [
          {
            label: 'Alle',
            backgroundColor: '#2dc46c',
            data: this.sumMonth,
          },
          {
            label: 'Verrechnet netto',
            backgroundColor: '#b9dff8',
            data: this.sumVerr,
          },
          {
            label: 'Bezahlt netto',
            backgroundColor: '#36a2eb',
            data: this.sumBez,
          },
          {
            label: 'Offen netto',
            backgroundColor: '#ff6384',
            data: this.sumUnBez,
          },
        ]
      },
      options: {
        legend: {
          labels: {
            fontFamily: "Avenir",
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          backgroundColor: '#2c3e50',
          callbacks: {
            title: function(tooltipItem, data) {
              return moment(tooltipItem[0].xLabel).format('MMM')
            },
            label: function(tooltipItem, data) {
              return 'Summe: ' + parseFloat(tooltipItem.yLabel).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
            }
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: "Avenir",
            },
            offset: true,
            type: 'time',
            time: {
              unit: 'month',
              displayFormats: {
                month: 'MMM'
              }
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: "Avenir",
            }
          }]
        }
      }
    }
  },
  watch: {
    sumMonth: function(newD, old) {
      this.chartdata.datasets[0].data = newD
      this.renderChart(this.chartdata, this.options)
    },
    sumVerr: function(newD, old) {
      this.chartdata.datasets[1].data = newD
      this.renderChart(this.chartdata, this.options)
    },
    sumBez: function(newD, old) {
      this.chartdata.datasets[2].data = newD
      this.renderChart(this.chartdata, this.options)
    },
    sumUnBez: function(newD, old) {
      this.chartdata.datasets[3].data = newD
      this.renderChart(this.chartdata, this.options)
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.options)
  }
}